import { TrainingMembershipsDataTableQuery } from 'generated/resources/datatable.graphql'
import compact from 'lodash/compact'

import { useDataTable } from 'modules/core/components/DataTable'

import { DeleteParticipantsModal } from 'modules/trainings/components/Revamp/TrainingsDetail/TrainingEmployeesDataTable/DeleteParticipantsModal'

const DeleteParticipants = () => {
  const data = useDataTable<TrainingMembershipsDataTableQuery>()
  const selectedMembershipIds = compact(
    data.queryResult.data?.trainings.trainingMembershipsConnection.edges.map((membership) => {
      if (data.selectedRows.has(String(membership.node?.id))) {
        return membership.node?.id
      }
    })
  )

  return <DeleteParticipantsModal membershipIds={selectedMembershipIds} />
}

export default DeleteParticipants
